<template>
    <tr>
        <td class="jetton-list-name">
            <div class="jetton-list-link">
                <ui-link v-bind:to="{ name: 'token', params: { address: canonizeAddress(jetton) }}">
                    <ui-round-image class="jetton-list__icon" size="tiny" v-bind:src="image"/>
                    <span style="font-weight: 500">{{ truncateTicker(name) || jetton }}</span>
                </ui-link>
                <div class="muted jetton-list-ticker">{{ truncateTicker(symbol) }}</div>
            </div>
        </td>
        <td style="max-width: fit-content;">
            <b>{{ $ton(balance, decimals) }}</b>
            <span style="margin-left: 2px;">{{ symbol }}</span>
            <span style="margin-left: 2px;" class="muted">
                &asymp;
                <ui-format-price v-bind:price="balancePrice" v-bind:symbol="currencySymbol"/>
            </span>
        </td>
        <td class="ui-table__cell--align-right">
            <ui-link v-bind:to="{ name: 'token-wallet', params: { address: canonizeAddress(jettonWallet) }}">
                <ui-address v-bind:address="canonizeAddress(jettonWallet)" disabled />
            </ui-link>
        </td>
    </tr>
</template>

<script>
import { truncateTicker } from '~/helpers.js';
import { canonizeAddress } from '~/tonweb.js';

export default {
    props: {
        image: String,
        name: String,
        symbol: String,
        balance: String,
        decimals: [Number, String],
        jetton: String,
        jettonWallet: String,
        jettonPrice: Number,
        balancePrice: Number,
        currencySymbol: {
            type: String,
            default: '$',
        },
    },

    methods: {
        truncateTicker,
        canonizeAddress,
        // getJettonRate(wallet) {
        //     const jettonsCount = parseFloat(formatTons(wallet.balance, wallet.jetton_meta.decimals).replace(/\s/g, '').replace(',', '.'));
        //
        //     const rate = this.rates.filter(({ id }) => id === wallet.jetton_address);
        //
        //     if (rate.length > 0) {
        //         return rate[0].price * jettonsCount;
        //     }
        //
        //     return null;
        // },
    },
};
</script>

<style lang="scss">
.price-token-table {
    font-weight: 500;
}
.jetton-list-link a {
    display: inline-flex;
    align-items: center;
}
.jetton-list-ticker {
    margin-left: 6px;
}
.jetton-list-name {
    min-width: fit-content;
    width: 1px;
}
</style>
